import {ApplicationError} from "../errors/ApplicationError";


export enum WebApiErrorType {
    INVALID_REQUEST = 1,

    ABORT = 2,

    APPLICATION_ERROR = 100,

    NOT_FOUND = 101,

    ACCESS_DENIED = 102,

    SERVER_ERROR = 200,

    UNAVAILABLE = 201,

    DEFAULT = 0
}


export type IWebApiError = {
    type: WebApiErrorType;
    typeName: string;
    errorCode: string;
    errorMessage: string;
}

export class WebApiError extends ApplicationError {

    private error: IWebApiError = {
        type: 0,
        typeName: "",
        errorCode: "",
        errorMessage: ""
    };

    setError(error: IWebApiError): WebApiError {
        this.error = error;
        return this;
    }

    getType(): number {
        return this.error.type;
    }

    getCode(): string {
        return this.error.errorCode;
    }

    isServerError() {
        return this.error.type >= WebApiErrorType.SERVER_ERROR;
    }

    isAppError() {
        return WebApiErrorType.APPLICATION_ERROR <= this.error.type &&
            this.error.type < WebApiErrorType.SERVER_ERROR;
    }

    isAbort() {
        return WebApiErrorType.ABORT === this.error.type;
    }

}
